import { FilterOption, SortOption } from '../../backend/backendapi';

export class VgtRemoteManger<T> {
  parameters: VgtParameters = new VgtParameters();

  private readonly loadingFunction: LoadingFunction<T>;
  private pendingReload = false;
  private loadingFuture: Promise<void> | null = null;
  results: Results<T> = new Results<T>();
  private searchDelayTask: number = 0;

  get isLoading(): boolean {
    return !!this.loadingFuture;
  }

  constructor(loadingFunction: LoadingFunction<T>) {
    this.loadingFunction = loadingFunction;
  }

  pageEvent(event: { currentPage: number, prevPage: number, currentPerPage: number, total: number }): void {
    // params.currentPage - current page that pagination is at
    // params.prevPage - previous page
    // params.currentPerPage - number of items per page
    // params.total - total number of items in the table
    // console.log('pageEvent', event);
    this.parameters.pagination.page = event.currentPage - 1;
    this.parameters.pagination.perPage = event.currentPerPage;
    this.reload();
  }

  sortEvent(event: { field: string, type: 'asc' | 'desc' }[]): void {
    // params[0].sortType - ascending or descending
    // params[0].columnIndex - index of column being sorted
    // console.log('sortEvent', event);
    this.parameters.sort = event
      .filter(e => ['asc', 'desc'].includes(e.type))
      .filter(e => e.field)
      .map(e => new SortOption({column : e.field, descending: e.type == 'desc'}))
    this.reload();
  }

  filterEvent(event): void {
    // params.columnFilters - filter values for each column in the following format:
    // {field1: 'filterTerm', field3: 'filterTerm2')
    // console.log('filterEvent', event);
    this.reload();
  }

  perPageEvent(event: { currentPage: number, currentPerPage: number, total: number }): void {
    // params.currentPage - current page that pagination is at
    // params.currentPerPage - number of items per page
    // params.total - total number of items in the table
    // console.log('perPageEvent', event);
    this.parameters.pagination.perPage = event.currentPerPage;
    this.reload();
  }

  searchEvent(event: { searchTerm: string, rowCount: number }): void {
    // params.searchTerm - term being searched for
    // params.rowCount - number of rows that match search
    // console.log('searchEvent', event);
    this.parameters.search = event.searchTerm;
    
    clearTimeout(this.searchDelayTask);
    this.searchDelayTask = setTimeout(() => this.reload(), 400); //debounce 
  }

  async reload(): Promise<void> {
    if (this.loadingFuture) {
      this.pendingReload = true;
      return;
    }

    this.loadingFuture = this.load();
    try {
      await this.loadingFuture;
    } catch (err) {
      console.log(err);
    }
    this.loadingFuture = null;

    //reload again if another reload was scheduled while this reload was in progress
    if (this.pendingReload) {
      this.pendingReload = false;
      await this.reload();
    }
  }

  private async load(): Promise<void> {
    this.results = await this.loadingFunction(this.parameters);
  }
}


export class VgtParameters {
  pagination: { page: number, perPage: number } = { page: 0, perPage: 10 };
  filter: FilterOption[] = [];
  sort: SortOption[] = [];
  search = '';
}

export class Results<T> {
  totalRows: number = 0;
  data: T[] = [];
}

export type LoadingFunction<T> = (params: VgtParameters) => Promise<Results<T>>;
